import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[ccPositiveNumberInput]',
})
export class PositiveNumberInputDirective {
  @Input() ccPositiveNumberInput: NgModel;

  constructor(private elementRef: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange() {
    const inputValue = this.elementRef.nativeElement.value;
    const isClearing = inputValue === '';
    const hasExponent = inputValue.includes('e');
    const validNumber = this.ccPositiveNumberInput.valid && !hasExponent;
    const validPositiveNumber = validNumber && parseFloat(inputValue) >= 0;
    const updatedValue = validPositiveNumber || isClearing ? inputValue : 0;

    this.elementRef.nativeElement.value = updatedValue;
    this.ccPositiveNumberInput.update.emit(parseFloat(updatedValue || 0));
  }
}
